import { Card, CardContent, CardFooter } from "@/shared/components/ui/card";
import "./not-found-page.scss";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/components/ui/button";
import { useNavigate } from "react-router-dom";
import Logo from "@/shared/components/logo/logo";

export default function NotFoundPage() {
  const { t: notFoundT } = useTranslation("notfound");
  const { t: commonT } = useTranslation("common");
  const navigate = useNavigate();
  return (
    <div className="not-found-page flex h-screen w-full flex-col items-center justify-center relative">
      <div className="not-found-page__logo flex items-center justify-center">
        <Logo style={{ height: "34px" }} />
      </div>
      <Card className="not-found-page__card flex flex-col items-center justify-center">
        <div className="not-found-page__card-header">
          <img
            src={"/images/404-ufo.png"}
            alt="Not Found"
            className="not-found-page__card-image "
          />
        </div>
        <CardContent className="not-found-page__card-content text-center gap-3 p-6 flex flex-col items-center justify-center">
          <h1 className="text-2xl font-700 card-foreground">
            {notFoundT("notFound")}
          </h1>
          <p className="text-base text-muted-foreground">
            {notFoundT("notFoundDescription")}
          </p>
        </CardContent>
        <CardFooter className="not-found-page__card-footer pt-0 px-6 pb-6">
          <Button
            className="not-found-page__card-footer-button"
            onClick={() => navigate("/")}
          >
            {commonT("go_to_home")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
